import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { PredecoratedDate } from "cc-frontend/lib/date-formatter"
import type ModalManager from "cc-frontend/services/modal-manager"
import type Session from "cc-frontend/services/session"
import _ from "lodash"

@tagName("")
export default class MonthMenu extends Component {
  // Args
  courses!: Array<Course>
  visibleCourses!: Array<Course>
  planbook!: Planbook
  dateRangeString!: string
  startDate!: PredecoratedDate
  endDate!: PredecoratedDate
  isFilteringClasses!: boolean
  classesLinedUp!: boolean
  openOnHover!: boolean
  perspective!: string
  currentYearMonth!: string
  closeMenu!: Function
  hiddenCourseIds: Array<string> = []

  // Properties
  menuIsOpen = false

  // Services
  @service session!: Session
  @service modalManager!: ModalManager

  // init
  // Cps/getters

  // Actions

  @action
  printOrDownload() {
    this.closeMenu()

    if (this.session.isAuthenticated !== true) {
      this.session.mustSignInToProceed("Print/Download Day")
      return
    }

    if (_.includes(this.session.user.content.meta.permissions, "can-print-month")) {
      this.modalManager.openModal("planner/modals/print-download", {
        courseIds: _.chain(this.courses)
          .map((course) => course.id)
          .reject((courseId) => _.includes(this.hiddenCourseIds, courseId))
          .value(),
        isFilteringClasses: this.isFilteringClasses,
        classesLinedUp: this.classesLinedUp,
        planbookId: this.planbook.id,
        startDate: this.startDate.dateString,
        endDate: this.endDate.dateString,
        currentUserId: this.session.userId,
        dateRangeString: this.dateRangeString,
        layout: this.perspective,
        canPrint: _.includes(this.session.user.content.meta.permissions, "can-print-month"),
      })
    } else {
      this.modalManager.openModal("planner/modals/print-paywall", {})
    }
  }
}
